import React from "react";

export function Disclaimer({ t }) {
  return (
  <div className="disclaimer">
      <span>⚠️</span>
      <span>{t("disclaimer_text")}</span>
    </div>
  );
}
